/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assistantsListExecutionProfiles } from "../funcs/assistantsListExecutionProfiles.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListExecutionProfilesResult } from "../models/components/listexecutionprofilesresult.js";
import {
  ListAssistantExecutionProfilesRequest,
  ListAssistantExecutionProfilesSecurity,
} from "../models/operations/listassistantexecutionprofiles.js";
import { unwrapAsync } from "../types/fp.js";
export type AssistantExecutionProfilesQueryData = ListExecutionProfilesResult;

export function prefetchAssistantExecutionProfiles(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListAssistantExecutionProfilesRequest,
  security?: ListAssistantExecutionProfilesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAssistantExecutionProfilesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAssistantExecutionProfilesQuery(
  client$: GramCore,
  request: ListAssistantExecutionProfilesRequest,
  security?: ListAssistantExecutionProfilesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AssistantExecutionProfilesQueryData>;
} {
  return {
    queryKey: queryKeyAssistantExecutionProfiles({
      assistantId: request.assistantId,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function assistantExecutionProfilesQueryFn(
      ctx,
    ): Promise<AssistantExecutionProfilesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(assistantsListExecutionProfiles(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAssistantExecutionProfiles(
  parameters: {
    assistantId: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "assistants", "listExecutionProfiles", parameters];
}
